import React, { useState } from 'react';

import { DailyProgress } from '../../components/DailyProgress';
import { SprintsDropdown } from '../../components/SprintsDropdown';
import { SprintSummary } from '../../components/SprintSummary';
import { SprintProvider, useSprint } from '../../contexts/SprintContext';
import { useTeam } from '../../contexts/TeamContext';
import { useSprints } from '../../hooks/useSprints';

export function TeamViewContainer(): JSX.Element {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const { team } = useTeam();
  const { selectedSprint, setSelectedSprint } = useSprint();
  const { data: sprints, isLoading } = useSprints(team?.id ?? null);
  return (
    <div className="pt-6 space-y-6">
      <SprintsDropdown
        className="max-w-80"
        selectedSprint={selectedSprint}
        setSelectedSprint={setSelectedSprint}
        sprints={sprints}
        setSelectedDate={setSelectedDate}
        isLoading={isLoading}
      />
      <SprintSummary />
      <DailyProgress
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        selectedSprint={selectedSprint}
        setSelectedSprint={setSelectedSprint}
        sprints={sprints}
        isLoading={isLoading}
      />
    </div>
  );
}

export function TeamView(): JSX.Element {
  return (
    <SprintProvider>
      <TeamViewContainer />
    </SprintProvider>
  );
}
